import axios from "axios";
import { toast } from "sonner";
import { Pencil, Trash2, Plus } from "lucide-react";
import { API, useAuth } from "@/App";
import { useContent } from "@/lib/content";

export const useLiveDelete = () => {
  const { token } = useAuth();
  return async (path, label, onDone) => {
    if (!window.confirm(`Remove "${label}"?`)) return;
    try {
      await axios.delete(`${API}/admin/${path}`, { headers: { Authorization: `Bearer ${token}` } });
      toast.success("Removed");
      onDone();
    } catch (error) {
      toast.error("Failed to remove");
    }
  };
};

export const LiveItemControls = ({ id, onEdit, onDelete, className = "" }) => {
  const { editMode } = useContent();
  if (!editMode) return null;
  const stop = (fn) => (e) => { e.preventDefault(); e.stopPropagation(); fn(); };
  return (
    <div className={`absolute top-2 right-2 z-20 flex gap-1 ${className}`} onClick={(e) => e.preventDefault()}>
      <button type="button" onClick={stop(onEdit)} data-testid={`live-edit-item-${id}`} aria-label="Edit" className="p-1.5 rounded-full bg-charcoal/85 text-ivory hover:bg-charcoal">
        <Pencil className="w-3.5 h-3.5" />
      </button>
      <button type="button" onClick={stop(onDelete)} data-testid={`live-delete-item-${id}`} aria-label="Remove" className="p-1.5 rounded-full bg-lipstick-red/90 text-white hover:bg-lipstick-red">
        <Trash2 className="w-3.5 h-3.5" />
      </button>
    </div>
  );
};

export const LiveAddButton = ({ label, onClick, testId }) => {
  const { editMode } = useContent();
  if (!editMode) return null;
  return (
    <button type="button" onClick={onClick} data-testid={testId}
      className="inline-flex items-center gap-2 px-4 py-2 rounded-full border-2 border-dashed border-champagne-gold text-champagne-gold font-body text-xs tracking-widest uppercase hover:bg-champagne-gold/10 transition-colors">
      <Plus className="w-4 h-4" /> {label}
    </button>
  );
};
